import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterSeatsSearchValueObject extends ValueObject {
  #seats

  constructor({seats}) {
    super()
    this.#seats = seats
  }

  static create({seats}) {
    return new FilterSeatsSearchValueObject({seats: FilterRangeSearchValueObject.create(seats)})
  }

  static createWithDefaultValue({config, seats}) {
    const {DEFAULT_SEATS_SEARCH} = config.get('searchFilters')

    return new FilterSeatsSearchValueObject({
      seats: FilterRangeSearchValueObject.create({
        from: seats?.from || DEFAULT_SEATS_SEARCH.from,
        to: seats?.to || DEFAULT_SEATS_SEARCH.to
      })
    })
  }

  static createQueryParams({config, seats}) {
    const {DEFAULT_SEATS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterSeatsSearchValueObject({
      seats: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.SEAT].from,
          value: seats?.from || DEFAULT_SEATS_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.SEAT].to,
          value: seats?.to || DEFAULT_SEATS_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#seats.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#seats.from.isEmpty && {...this.#seats.from.queryParam}),
      ...(!this.#seats.to.isEmpty && {...this.#seats.to.queryParam})
    }
  }

  get value() {
    return this.#seats.value
  }

  toJSON() {
    return {
      seats: this.#seats.toJSON()
    }
  }
}
